module.exports = __webpack_public_path__ + "img/43_62.a1aa1b20.png";